module.exports = __webpack_public_path__ + "media/images/png/bg-alert-5cfe1924873471210cc08be1fc3ba42c.png";